import moment from 'moment'

const formatTime = isoString => moment(isoString).format('M/D/YYYY, h:mm:ss a')

function convertTimeZonedTimeToLocal(timeZoneOffset, time) {

  // split time into two strings and then map them to an array of numbers
  const [hours, minutes] = time.split(':').map(string => parseInt(string, 10))

  const date = new Date();
  const localOffsetHours = date.getTimezoneOffset() / 60;
  date.setMinutes(minutes)
  // Incoming timeZoneOffset is negative. 
  // Adding it to localOffset give us the correct converted local time
  date.setHours(hours + timeZoneOffset + localOffsetHours);
    
  return date.getTime()
}


function isLocalTimeAfter(timeZoneOffset, comparisonTimeString) {
  if (!comparisonTimeString) {
    return false;
  }
  
  const nowDate = new Date()
  const nowTime = nowDate.getTime()
  const comparisonTime = convertTimeZonedTimeToLocal(timeZoneOffset, comparisonTimeString);
  
  return nowTime > comparisonTime;
}

export { formatTime, isLocalTimeAfter }
